<template>
	<rr-section :background-color="$const.HTML_CLASS.BACKGROUND_COLOR.TRANSPARENT">
		<container-inner>
			<row>
				<column :width="2" :class="$style['left-column']">
					<rr-animate-text v-if="smallTitle" :text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT"
					          :text-type="$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL"
					          :before-icon="$const.HTML_CLASS.BEFORE_ICON.CIRCLE" :scroll-animation-delay=".15">{{ smallTitle }}
					</rr-animate-text>
					<slot name="left"></slot>
				</column>
				<column :width="2" :class="rightColumnClass">
					<slot name="right"></slot>
				</column>
			</row>
		</container-inner>
	</rr-section>
</template>

<script>
export default {
	name: 'PageIntroSection',
	// data() {
	// 	return {
	// 		slides: [
	// 			{img: 'https://dummyimage.com/wsvga'},
	// 			{img: 'https://dummyimage.com/wsvga'},
	// 			{img: 'https://dummyimage.com/wsvga'},
	// 			{img: 'https://dummyimage.com/wsvga'},
	// 		],
	// 		sliderAllCount: 0,
	// 		sliderActive: 1,
	// 		sliderOffsetLeft: 0,
	// 		sliderOffsetStep: 0,
	// 	}
	// },
	props: {
		smallTitle: {
			type: String,
		},
		rightColumnClass: {
			type: String,
		},
	},
	// methods: {
	// 	setBurgerPageYOffset() {
	// 		if (this.$el) {
	// 			const sr = this.$el.getBoundingClientRect(),
	// 				sy = sr.y + sr.height
	//
	// 			this.$store.commit('setBurgerPageYOffset', sy)
	// 		}
	// 	}
	// },
	// mounted() {
	// 	window.addEventListener('resize', this.setBurgerPageYOffset, false)
	// },
	// destroyed() {
	// 	window.removeEventListener('resize', this.setBurgerPageYOffset)
	// },
	// watch: {
	// 	'$store.state.isPreloaderHide'(value) {
	// 		if (value) {
	// 			this.setBurgerPageYOffset()
	// 		}
	// 	},
	// },
}
</script>

<style module lang="scss">
// left column
.left-column {
	@include space-responsive-margin-t(160);
	@include space-responsive-margin-b(202);
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		margin-top: 55px;
		margin-bottom: 25px;
	}
}
</style>
